import React from 'react';
import Modal from 'jd-library/Modal';
import styles from './missing-modal.scss';

const ModalWithSingleBtn = props => {
    const {
        infoText,
        onHidden,
        btnClick,
        btnText
    } = props;

    return (
        <Modal
            onHidden={onHidden}
            settings={{
                modalId: "missingModal",
                variant:'action',
                class: styles['missing-modal']
            }}
        >
            <Modal.Body className={styles['missing-modal-body']}>
                <span dangerouslySetInnerHTML={{__html: infoText}} />
            </Modal.Body>
            <Modal.CenterButton clickHandler={btnClick}>
			    {btnText}
		    </Modal.CenterButton>
        </Modal>
    )
};

export default ModalWithSingleBtn;